import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs,  Badge } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { Icon } from '@mdi/react';
import { mdiCheckDecagram } from '@mdi/js';

const pageSize = 20;

export const InvoicePendingPage = () => {
    const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [btnAuths, setBtnAuths] = useState(true);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);
  const { JWT, setJWT } = useGlobalState(); 

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [selectedItems, setSelectedItems] = useState<InvoiceItem[]>([]);
            const { setLoading } = useGlobalState();
  const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filteringText, setFilteringText] = useState('');
  const [invoices, setInvoices] = useState<InvoiceItem[]>([]);


  type InvoiceItem = {
    idFacturacion: number;
    fechaEmision: string;
    fechaVencimiento: string;
    fechaPago: string;
    neto: number;
    bruto: number;
    iva: number;
    rut: string;
    periodoIni: string;
    periodoFin: string;
    numDOC: number;
    dueDays: number;
    status: string;
  };
  const handleCheckboxChange = (facturacionId: string) => {
    setSelectedInvoices((prev) => {
      // If the access is already selected, remove it from the array, else add it
      if (prev.includes(facturacionId)) {
        return prev.filter(id => id !== facturacionId);
      } else {
        return [...prev, facturacionId];
      }
    });
  };
  const filteredInvoices = invoices.filter(invoice => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      invoice.numDOC.toString().toLowerCase().includes(word) ||
      invoice.neto.toString().toLowerCase().includes(word)
    );
  });

  const paginatedInvoices = filteredInvoices.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  const handleSelectionChange = ({ detail }: any) => {
    setSelectedItems(detail.selectedItems);
    setBtnActionDisable(detail.selectedItems.length === 0);
    if (detail.selectedItems.length > 1) setDrawerOpen(false);
  };

  useEffect(() => {
    setBtnAuths(selectedInvoices.length == 0)
  }, [selectedInvoices]); // The effect runs every time selectedAccesses changes

  // Handle row click to fetch additional data and open the HelpPanel
  const handleRowClick = async (rowData: InvoiceItem) => {
    setSelectedRow(rowData);  // Store selected row data
    try {
      // Simulate a fetch request to get additional data for the row
      // Example of a fetched data structure
      const invoiceDetails = {

        idFacturacion: rowData.idFacturacion,
        fechaEmision: rowData.fechaEmision,
        fechaVencimiento: rowData.fechaVencimiento,
        fechaPago: rowData.fechaPago,
        neto: rowData.neto,
        bruto: rowData.bruto,
        iva: rowData.iva,
        rut: rowData.rut,
        periodoIni: rowData.periodoIni,
        periodoFin: rowData.periodoFin,
        numDOC: rowData.numDOC,
        status: rowData.status,
        dueDays: rowData.dueDays,
      };
      setSelectedRow(invoiceDetails);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setDrawerOpen(true);
    }
  };
  useEffect(() => {
  }, [selectedRow]);
  const handleRefresh = async () => {
    try {setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/invoices/list',
          'JWT': JWT,
           
        },
        body: JSON.stringify({
          status:'V'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);
      setInvoices(data.invoices);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);

  return (
    <CustomAppLayout
      toolsOpen={drawerOpen}
      onToolsChange={({ detail }) => setDrawerOpen(detail.open)}
      tools={


        <Drawer header="">
          <div>
            {selectedRow ? (
              
              <>
                <h3>Documento #{selectedRow.numDOC}</h3>
                <KeyValuePairs
                  columns={2}
                  items={[
                    {
                      label: "Nº Documento",
                      value: selectedRow.numDOC
                    },
                    {
                      label: "Neto",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.neto)
                    },
                    {
                      label: "IVA",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.iva)
                    },
                    {
                      label: "Bruto",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.bruto)
                    },
                    {
                      label: "Emisión",
                      value: selectedRow.fechaEmision
                    },
                    {
                      label: "Vencimiento",
                      value: selectedRow.fechaVencimiento
                    },
                  ]}
                />

                <div style={{ height: '20px' }}></div>
                <SpaceBetween size='xs' direction="vertical">
                </SpaceBetween>
              </>
            ) : (
              <p>No hay datos seleccionados.</p>
            )}
          </div>
          <div style={{ height: '20px' }}></div>
          <SpaceBetween size='xs' alignItems="end" direction="horizontal">
            <Button variant="normal">Descargar</Button>
            <Button variant="normal">Enviar</Button>
          </SpaceBetween>
        </Drawer>
      }
      
      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Facturación', href: '#invoices' },
            { text: 'Vencidas', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <Table
            stripedRows
            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
              `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
            }
            onSelectionChange={handleSelectionChange}
            selectedItems={selectedItems}
            onRowClick={({ detail }) => handleRowClick(detail.item)}
            ariaLabels={{
              selectionGroupLabel: "Items selection",
              allItemsSelectionLabel: () => "select all",
              itemSelectionLabel: ({ selectedItems }, item) => item.idFacturacion.toString(),
            }}

            columnDefinitions={[
              {
                id: "numDOC",
                header: "DTE",
                cell: (item) => item.numDOC,
                width: 70,
                minWidth: 65,
                //sortingField: "numDOC",
                isRowHeader: true,
              },
              {
                id: "fechaEmision",
                header: "Emisión",
                cell: (item) => item.fechaEmision,
                //sortingField: "bruto",
              },
              {
                id: "bruto",
                header: "Total",
                cell: (item) => {
                  const amountFormatted = new Intl.NumberFormat('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(item.bruto);
                  return amountFormatted; // Return the formatted value
                },
                //sortingField: "bruto",
              },
              {
                id: "status",
                header: "Estado",
                cell: (item) => {
                  if (item.status === 'V') {
                    return (
                      <>
                        Vencida <Badge color='red'>{item.dueDays} día{item.dueDays==1?'':'s'}</Badge> 
                      </>
                    );
                  } else if (item.status === 'C') {
                    return `Pagada`;
                  } else if (item.status === 'P') {
                    return `Pendiente`;
                  }
                  return null;
                },
                //sortingField: "bruto",
              },
            ]}
            items={paginatedInvoices}
            selectionType="multi"
            trackBy="idFacturacion"
            empty={
              <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                <SpaceBetween size="m">
                  <Icon path={mdiCheckDecagram} size={1} color={"green"} />
                  <b>No tiene documentos tributarios vencidos</b>
                  
                </SpaceBetween>
              </Box>
            }
            /*
            filter={
              <TextFilter
                filteringText={filteringText}
                onChange={({ detail }) => {
                  setFilteringText(detail.filteringText);
                  setCurrentPageIndex(1);
                }}
              />
            }
            pagination={
              <Pagination
                currentPageIndex={currentPageIndex}
                pagesCount={Math.ceil(filteredInvoices.length / pageSize)}
                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
              />
            }

            preferences={
              <CollectionPreferences
                title="Preferencias"
                confirmLabel="Confirmar"
                cancelLabel="Cancelar"
                preferences={{
                  pageSize: 10,
                  contentDisplay: [
                    { id: "movil", visible: true },
                    { id: "displayName", visible: true },
                    { id: "accesos", visible: true },
                    { id: "unidad", visible: true }
                  ]
                }}
                pageSizePreference={{
                  title: "Paginación",
                  options: [
                    { value: 10, label: "10 items" },
                    { value: 20, label: "20 items" }
                  ]
                }}
                wrapLinesPreference={{}}
                stripedRowsPreference={{}}
                contentDensityPreference={{

                }}
                contentDisplayPreference={{
                  options: [
                    {
                      id: "movil",
                      label: "Movil",
                      alwaysVisible: true
                    },
                    { id: "displayName", label: "Nombre" },
                    { id: "unidad", label: "Unidad" },
                    { id: "accesos", label: "Accesos" }
                  ]
                }}
                stickyColumnsPreference={{
                  firstColumns: {
                    title: "Fijar primera columna(s)",
                    description:
                      "Mantener la primera columna(s) visibles mientras se hace scroll horizonal en el contenido de la tabla.",
                    options: [
                      { label: "Ninguno", value: 0 },
                      { label: "Primera columna", value: 1 },
                      { label: "Primeras dos columna", value: 2 }
                    ]
                  },
                  lastColumns: {
                    title: "Fijar última columna",
                    description:
                      "Keep the last column visible while horizontally scrolling the table content.",
                    options: [
                      { label: "Ninguno", value: 0 },
                      { label: "Última columna", value: 1 }
                    ]
                  }
                }}
              />
            }
              */
            header={
              <Header
                counter={
                  selectedItems.length
                    ? "(" + selectedItems.length + "/" + pageSize + ")"
                    : ""
                }
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    <ButtonDropdown
                      items={[
                        {
                          text: "Enviar por correo",
                          id: "email",
                          disabled: false
                        },
                        {
                          text: "Desgargar",
                          id: "download",
                          disabled: false
                        },
                      ]}
                      disabled={btnActionDisable}
                    >
                      Acciones
                    </ButtonDropdown>
                  </SpaceBetween>
                }
              >
              </Header>
            }
          />

        </>
      }
    />
  );
};
